import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storage1Service } from 'services/storage1Service';
import { parseApiError } from 'utils/errorParser';
import { notify } from 'features/ui/uiSlice';
import { MESSAGES } from 'constants/messages';

export const fetchStorage1 = createAsyncThunk('storage1/fetch', async (params, { rejectWithValue }) => {
  try {
    return await storage1Service.list(params);
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

export const fetchBundles = createAsyncThunk('storage1/bundles', async (_, { rejectWithValue }) => {
  try {
    return await storage1Service.listBundles();
  } catch (error) {
    return rejectWithValue(parseApiError(error));
  }
});

export const dispatchBundles = createAsyncThunk('storage1/dispatch', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const bundles = await storage1Service.dispatch(payload);
    dispatch(notify({ type: 'success', message: MESSAGES.PIPELINE.DISPATCHED }));
    return bundles;
  } catch (error) {
    const parsed = parseApiError(error);
    dispatch(notify({ type: 'error', message: parsed.message }));
    return rejectWithValue(parsed);
  }
});

export const manualUploadOCR = createAsyncThunk('storage1/manualUploadOCR', async (formData, { dispatch, rejectWithValue }) => {
  try {
    const article = await storage1Service.manualUploadOCR(formData);
    dispatch(fetchStorage1());
    return article;
  } catch (error) {
    const parsed = parseApiError(error);
    dispatch(notify({ type: 'error', message: parsed.message }));
    return rejectWithValue(parsed);
  }
});

const storage1Slice = createSlice({
  name: 'storage1',
  initialState: { items: [], total: 0, page: 1, totalPages: 0, pageSize: 20, bundles: [], status: 'idle', saving: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStorage1.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchStorage1.fulfilled, (state, action) => { 
        state.status = 'succeeded'; 
        state.items = action.payload.items; 
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
        state.pageSize = action.payload.pageSize;
      })
      .addCase(fetchStorage1.rejected, (state, action) => { state.status = 'failed'; state.error = action.payload?.message; })
      .addCase(fetchBundles.fulfilled, (state, action) => { state.bundles = action.payload; })
      .addCase(dispatchBundles.pending, (state) => { state.saving = true; })
      .addCase(dispatchBundles.fulfilled, (state, action) => { state.saving = false; state.bundles = action.payload; })
      .addCase(dispatchBundles.rejected, (state) => { state.saving = false; })
      .addCase(manualUploadOCR.pending, (state) => { state.saving = true; })
      .addCase(manualUploadOCR.fulfilled, (state) => { state.saving = false; })
      .addCase(manualUploadOCR.rejected, (state) => { state.saving = false; });
  },
});

export default storage1Slice.reducer;
